import React from 'react';
export class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.render = () => {
            const animationStyle = this.props.visible ? 'animate-fade-in' : 'animate-fade-out';
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { hidden: this.state.hidden, className: `animation-duration-300 animation-fill-forwards ${animationStyle}`, style: this.props.style },
                    React.createElement("div", { className: 'fixed inset-0 z-30 flex items-end sm:items-center sm:justify-center bg-black bg-opacity-50' },
                        React.createElement("div", { className: 'w-full px-6 py-3 sm:m-4 sm:max-w-xl bg-base-800 border-1 rounded-t-lg sm:rounded-lg border-base-700 overflow-hidden' },
                            React.createElement("div", { className: 'mt-4 mb-2' }, this.props.children))))));
        };
        this.state = { hidden: false };
    }
    componentDidMount() {
        if (!this.props.visible) {
            this.setState({ hidden: true });
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visible !== this.props.visible && this.state.hidden) {
            this.setState({ hidden: false });
        }
    }
}
